module.exports = __webpack_public_path__ + "img/material_selection.0c22a59.webp";